export default __webpack_public_path__ + "static/media/cover3.0a4bcff7.jpg";